import { useEffect, useState } from "react";
import useQuery from "../utils/UseQuery";
import { ClipLoader } from "react-spinners";
import { ButtonStyle } from "../utils/Buttons/Buttons";
import { canContinue, getColorsByCodeId } from "./hyperFlowApi";

const HyperFlowContinue = () => {
  function delay(ms: number) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }
  //query params
  const query = useQuery();
  const code = query.get("code") ?? "error";
  //State selectors

  //local states
  const [bgColor, setBgColor] = useState(["#ffffff", "#ffffff"]);
  const [darkMode, setDarkMode] = useState(true);
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState("");
  const [url, setUrl] = useState("");
  const [noWaitMessage, setNoWaitMessage] = useState(
    "Tu proceso está en revisión. Te enviaremos un correo para continuar."
  );
  const [continueMessage, setContinueMessage] = useState(
    "Continuemos con tu proceso"
  );

  //get colors
  async function getColors() {
    let resp = await getColorsByCodeId(code);
    setBgColor([resp.backgroundColor1, resp.backgroundColor2]);
    setDarkMode(resp.darkMode);
  }

  async function canContinueF() {
    setLoading(true);
    let resp = await canContinue(code);
    console.log(resp);
    let userAction = "WAIT";
    if (resp) {
      setStatus(resp.userAction);
      userAction = resp.userAction;
      if (resp.url) {
        setUrl(resp.url);
      }
    }
    setLoading(false);
    let keepAsking = false;
    if (userAction === "WAIT" || userAction === "DONT_WAIT") {
      if (userAction === "DONT_WAIT") {
        if (resp?.message !== null && resp?.message !== "") {
          setNoWaitMessage(
            resp?.message ??
              "Tu proceso está en revisión. Te enviaremos un correo para continuar."
          );
        }
      }
      keepAsking = true;
    } else {
      if (resp?.autoAdvance === true && userAction === "CONTINUE") {
        console.log(resp?.url ?? "");
        window.location.href = resp?.url ?? "";
        return;
      }
      if (resp?.message !== null && resp?.message !== "") {
        setContinueMessage(resp?.message ?? "Continuemos con tu proceso");
      }
    }
    while (keepAsking) {
      await delay(5000);
      console.log("keep asking");
      let resp = await canContinue(code);
      console.log(resp);
      if (resp) {
        setStatus(resp.userAction);
        userAction = resp.userAction;
        if (resp.url) {
          setUrl(resp.url);
        }
      }
      if (userAction === "WAIT" || userAction === "DONT_WAIT") {
        keepAsking = true;
        if (userAction === "DONT_WAIT") {
          if (resp?.message !== null && resp?.message !== "") {
            setNoWaitMessage(
              resp?.message ??
                "Tu proceso está en revisión. Te enviaremos un correo para continuar."
            );
          }
        }
      } else {
        if (resp?.autoAdvance === true && userAction === "CONTINUE") {
          console.log(resp?.url ?? "");
          window.location.href = resp?.url ?? "";
          return;
        }
        if (resp?.message !== null && resp?.message !== "") {
          setContinueMessage(resp?.message ?? "Continuemos con tu proceso");
        }
        keepAsking = false;
      }
    }
  }

  async function redirect() {
    window.location.href = url;
  }

  useEffect(() => {
    getColors();
    canContinueF();
  }, []);

  const customStyle = {
    "--fontColorPrimary": darkMode ? "#ffffff" : "#000000",
  } as React.CSSProperties;
  //Render
  return (
    <div className="hfMaster" style={customStyle}>
      <div
        style={{
          background: `radial-gradient(${bgColor[0]}, ${bgColor[1]})`,
          position: "fixed",
          height: "100%",
          width: "100%",
          overflow: "auto",
        }}
      >
        <div
          style={{
            position: "absolute",
            top: "50%",
            transform: "translate(-50%, -50%)",
            left: "50%",
          }}
        >
          {loading && (
            <div>
              <h1
                className="txt-label-title-hf"
                style={{ fontSize: "", marginBottom: "50px" }}
              >
                Espera un momento
              </h1>
              <ClipLoader
                loading={loading}
                size={150}
                color={darkMode ? "#FFFFFF" : "#000000"}
              />
            </div>
          )}

          {!loading && (
            <div>
              {status === "WAIT" && (
                <div>
                  <h1
                    className="txt-label-title-hf"
                    style={{ fontSize: "", marginBottom: "50px" }}
                  >
                    Espera un momento, estamos procesando tu información
                  </h1>
                  <ClipLoader loading={true} size={150} color={"#FFFFFF"} />
                </div>
              )}
              {status === "DONE" && (
                <div>
                  <h1
                    className="txt-label-title-hf"
                    style={{ fontSize: "", marginBottom: "50px" }}
                  >
                    ¡Tu proceso ha terminado!
                  </h1>
                  <ButtonStyle
                    onClick={() => {
                      window.location.href = url;
                    }}
                    text="Terminar"
                    width="177px"
                    height="5vh"
                  />
                </div>
              )}
              {status === "CONTINUE" && (
                <div>
                  <h1
                    className="txt-label-title-hf"
                    style={{ fontSize: "", marginBottom: "50px" }}
                  >
                    {continueMessage}
                  </h1>
                  <ButtonStyle
                    onClick={() => {
                      window.location.href = url;
                    }}
                    text="Continuar"
                    width="177px"
                    height="5vh"
                  />
                </div>
              )}
              {status === "DONT_WAIT" && (
                <div>
                  <h1
                    className="txt-label-title-hf"
                    style={{ fontSize: "", marginBottom: "50px" }}
                  >
                    {noWaitMessage}
                  </h1>
                  <h1
                    className="txt-label-title-hf"
                    style={{ fontSize: "", marginBottom: "50px" }}
                  >
                    Puedes cerrar esta ventana
                  </h1>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default HyperFlowContinue;
